import encryptedDataService from './encryptedDataService';
import storageService from '../utils/storageService';

class ApiDomainService {
  replaceSubdomain() {
    const subdomainFromUrl = window.location.hostname.split('.')[0];
    storageService.setItem('Tenant_Name', subdomainFromUrl);

    const RAW_API = process.env.REACT_APP_API_BASE_URL || "https://subdomain.myhello.in/api";

    // let zentech = 'main' //only for testing
    // const api = RAW_API.replace('subdomain', zentech);

    // let tempcorp = 'zentcorp'//only for testing
    // // let tempcorp = 'procom'//only for testing
    // const api = RAW_API.replace('subdomain', tempcorp); // only for a testing

    // let tempcomm = 'zentcomm'//only for testing
    // const api = RAW_API.replace('subdomain', tempcomm); // only for a testing

    // let tempcomm = 'centrumaccess'//only for testing
    // const api = RAW_API.replace('subdomain', tempcomm); // only for a testing

    // let cascade = 'cascade' //only for testing
    // let tempres = 'zentres' //only for testing
    // const api = RAW_API.replace('subdomain', tempres); // only for a testing

    const api = RAW_API.replace('subdomain', subdomainFromUrl); // for production

    const actualSubdomainMatch = api.match(/https?:\/\/([^.]+)\./);
    const actualSubdomain = actualSubdomainMatch ? actualSubdomainMatch[1] : subdomainFromUrl;
    storageService.setItem('Tenant_Name', actualSubdomain);

    return api;
  }
}

const apiDomainService = new ApiDomainService();
export default apiDomainService;
